import axios from 'axios'
// import { createStore } from 'redux'
// import { getToken } from '@/utils/auth'

import qs from 'qs'
import store from '@/redux'
import { guid } from './wogoo_utils'
import bwmodel from '@/config/bwmodel'
import moment from 'moment'
import token from './cookie'
import {changeRefreshToken, refreshToken} from '@/redux/actions'
// create an axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_WOGOO_SERVER, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  responseType: 'json',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
})
// store.dispatch(changeRefreshToken())
// request interceptor
service.interceptors.request.use(
  async config => {

    let state = store.getState()
    config.headers = {
      'X-Tracking-ID': guid(),
      'X-User-ID': state.user.userId,
      'X-Device-NO': state.user.deviceNo,
      'X-System-Type': bwmodel.system === 'iPhone' ? 2 : (bwmodel.system === 'Android' ? 1 : 3),
      'X-Device-Type': state.user.deviceType,
      'X-System-Version': state.user.systemVersion,
      'X-App-Version': 'h5'
    }
   
    let accessToken = state.user.accessToken
    let exp = state.user.expires
    if (accessToken) {
      if (moment().isAfter(exp)) {
        if(state.user.refreshStatus) {
          await store.dispatch(changeRefreshToken())
        } else {
          await store.dispatch(refreshToken())
        }
        accessToken = store.getState().user.accessToken
      }
      config.headers.Authorization = 'encrypt ' + accessToken
    }

    if(process.env.NODE_ENV === 'development') {
        config.headers.Authorization = token;
    }

    // config.headers.Authorization = 'encrypt eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyTmFtZSI6IuS5nem-meiXpOi_mOWNjuiIquiLjeiLjeWlveiIquW-iOiIquW-iOS5hei_lOWbnui3n-iIquiIquWImiIsInVzZXJJZCI6IjM1NzNkODU4NTNlMDQzNDI4MDc4MjAyZDU0ZDA5YjQ3IiwiZXhwaXJhdGlvbldpdGhUaW1lWm9uZSI6IjIwMjYtMDUtMTlUMTM6NTY6MzUuMDkzKzA4MDAiLCJpc3MiOiJ3b2dvby5jb20iLCJpYXQiOjE3NzkxNjgzOTUsImV4cCI6MTc3OTE3MDE5NSwianRpIjoiNDU1MTI5NGEtYWZhZi00NDAyLWEwNDUtMzgxYWU0MWIyNTNlIn0.SL-HPBQEkhpE8pYG5t9ByA64TkO4wSM9mUFXoABiAajyhAf1qtYS2d5nMm5FrxGSIuBVjDWzQWHjCpAQSgw7C8zUMOOfbIUzS2XpikBISztTLBYXBv8rNtmLG1D4HyhDxxRlYhWy8BtjT4LOLRfGPBMrtNWWpEjaElfDqhw5sBDcH6_SEdAKPRROupbrbFbLyevPjeT8pz5VE-Rwz-K4QdTk8nT7fPI7wr9uqSCKPzIAuJlU7BbeQlYGn2IAWr1zzd9Re8Ol0NcJu9Iec77MElVem6-WPZMuyy-h06r5LYx4LFbf595kvQatimBzLc5TIUIjVe4EBzzByLMzDzf0pg';
    if (config.method === 'post' && config.baseURL === process.env.REACT_APP_BASE_API ) {
      if (Object.prototype.toString.call(config.data) === '[object Object]') {
        if(config.formType !== '1' && !config.headers['Content-Type']) {
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8;'
          config.data = qs.stringify({...config.data})
        }
      }
    }
    
   
    if (config.baseURL.indexOf('/chaos/api') === 0) {
      config.baseURL = process.env.REACT_APP_BASE_API_CHAOS + config.baseURL 
    } else if (config.baseURL !== process.env.REACT_APP_WOGOO_SERVER ) {
      config.baseURL = (process.env.REACT_APP_WOGOO_SERVER  || '') + config.baseURL
    }
    if (config.header) {
      config.headers = {
        ...config.headers,
        ...config.header
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res

    // if the custom code is not 20000, it is judged as an error.
    // if (res.resultCode !== '00' && res.state != 'SUCCESS') {
    //   if (response.config.responseType != 1) {
    //     Message({
    //       message: res.resultMsg || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.resultCode === '200') {
    //     // to re-login
    //     MessageBox.confirm('身份已失效，是否确定重新登录', '提示', {
    //       confirmButtonText: '重新登录',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(res)
    // } else {
    //   return res
    // }
  },
  error => {
    // console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service